/**
 * Returns a boolean if value parameter is null or undefined
 */
export function isNullOrUndefined<T>(
    value: T | null | undefined,
): value is null | undefined {
    return value === null || value === undefined;
}
